import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface AppWrapperProps {
    children: React.ReactNode;
}

const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const currentotreset = params.get('otreset');
        const currentotpreview = params.get('otpreview');
        const currentotgeo = params.get('otgeo');

        if (currentotreset) {
            localStorage.setItem('otreset', currentotreset);
        }
        if (currentotpreview) {
            localStorage.setItem('otpreview', currentotpreview);
        }

        if (currentotgeo) {
            localStorage.setItem('otgeo', currentotgeo);
        }

        const otreset = localStorage.getItem('otreset');
        const otpreview = localStorage.getItem('otpreview');
        const otgeo = localStorage.getItem('otgeo');

        // If route doesn't have otreset,otpreview,otgeo in URL, but we have it stored, append it
       if ((!currentotreset && otreset) || (!currentotpreview && otpreview)
        || (!currentotgeo && otgeo)) {
        if ((!currentotreset && otreset)) {
            params.set('otreset', otreset);
        }
        if ((!currentotpreview && otpreview)) {
            params.set('otpreview', otpreview);
        }
        if ((!currentotgeo && otgeo)) {
            params.set('otgeo', otgeo);
        }

        navigate(
                {
                    pathname: location.pathname,
                    search: params.toString(),
                },
                { replace: true },
            );
        }
    }, [location, navigate]);

    return <div key={location.key}>{children}</div>;
};

export default AppWrapper;
